export enum ENUM_CARD_TYPE {
  LINK = 'LINK',
  POST = 'POST',
  EMBED = 'EMBED',
}
